import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const setTokens = (data) => {
  if (data?.token) localStorage.setItem("onekite_token", data.token);
  if (data?.refresh_token) localStorage.setItem("onekite_refresh", data.refresh_token);
};
export const setToken = (t) => localStorage.setItem("onekite_token", t);
export const clearToken = () => {
  localStorage.removeItem("onekite_token");
  localStorage.removeItem("onekite_refresh");
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("onekite_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Transparent access-token refresh using the rotating refresh token.
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || "";
    const isAuthPath =
      url.includes("/auth/refresh") || url.includes("/auth/login") || url.includes("/auth/customer/login");
    const hasRefresh = localStorage.getItem("onekite_refresh");
    if (status === 401 && original && !original._retry && !isAuthPath && hasRefresh) {
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = axios
            .post(`${API}/auth/refresh`, { refresh_token: localStorage.getItem("onekite_refresh") })
            .then((res) => {
              setTokens(res.data);
              return res.data.token;
            })
            .finally(() => {
              setTimeout(() => {
                refreshing = null;
              }, 0);
            });
        }
        const newToken = await refreshing;
        original.headers.Authorization = `Bearer ${newToken}`;
        return api(original);
      } catch (e) {
        clearToken();
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
